import {
  Button,
  Col,
  Flex,
  Form,
  Radio,
  Row,
  Select,
  Table,
  Tag,
  Typography,
} from "antd";
import React, { useCallback, useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getSystemSettingsAction } from "../../../../../../redux/services/addon-and-sponsorship/addonAndSponsorshipServices";
import useDebounce from "../../../../../../hooks/useDebounce";
import { appConstConfig } from "../../../../../../constants/config/appConstConfig";
import { dateObjToDispViewDate } from "../../../../../../utils/utils";
import { colors } from "../../../../../../constants/colors";
import Spinner from "../../../../../common/spinner/Spinner";
import {
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../../../../constants/routeConsts";
import { ArrowLeftOutlined } from "@ant-design/icons";
import styles from "./Configuration.module.scss";

const ConfigurationList = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* form dependencies */
  const [form] = Form.useForm();
  /* form dependencies */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [selectListLoader, setSelectListLoader] = useState(false);
  /* loading dependencies */

  /* table dependencies */
  const [columns, setColumns] = useState([]);
  const { tickets } = useSelector((state) => state.tickets);
  const [searchValue, setSearchValue] = useState("");
  const [pagination, setPagination] = useState({
    pageNo: appConstConfig.DEFAULT_TABLE_PAGE_NUMBER,
    pageSize: appConstConfig.DEFAULT_TABLE_PAGE_SIZE,
  });
  const paginationObj = {
    total: tickets?.total,
    current: pagination?.pageNo,
    pageSize: pagination?.pageSize,
    onChange: (pageNo, pageSize) => setPagination({ pageNo, pageSize }),
    pageSizeOptions: appConstConfig.DEFAULT_PAGE_SIZE_OPTIONS_ARR,
    showSizeChanger: true,
  };
  /* table dependencies */

  /* filter dependencies */
  const { debouncedValue: debouncedSearchValue, debounceLoading } = useDebounce(
    searchValue,
    500
  );
  const [selectedFilterStatus, setSelectedFilterStatus] = useState("user");
  /* filter dependencies */

  const { systemSettings } = useSelector((state) => state.addonAndSponsorship);

  const handleGetTableData = useCallback(() => {
    dispatch(getSystemSettingsAction(setLoading));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleGetTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilterStatus]);

  /* initial dependencies rendering */
  useEffect(() => {
    /* table column config */
    const tempTableColumns = [
      {
        title: t("Modules.Ads.srNo"),
        dataIndex: "index",
        key: "index",
        render: (_, record, index) => <p>{index + 1}</p>,
      },
      {
        title: t("Modules.Configuration.cancellationTimeLimit"),
        dataIndex: "time_limit_hours",
        key: "time_limit_hours",
        render: (_, record) => <p>{`${record?.time_limit_hours} hours`}</p>,
      },
      {
        title: t("Modules.Configuration.beforeTimeLimitRefundPercentage"),
        dataIndex: "before_time_limit_refund_percentage",
        key: "before_time_limit_refund_percentage",
        render: (_, record) => {
          return (
            <p>{`${record?.before_time_limit_refund_percentage || 0} %`}</p>
          );
        },
      },
      {
        title: t("Modules.Configuration.afterTimeLimitRefundPercentage"),
        dataIndex: "after_time_limit_refund_percentage",
        key: "after_time_limit_refund_percentage",
        render: (_, record) => (
          <p>{`${record?.after_time_limit_refund_percentage || 0} %`}</p>
        ),
      },
      {
        title: t("Modules.Configuration.doctorNoShowFine"),
        dataIndex: "organization_fine_percentage",
        key: "organization_fine_percentage",
        render: (_, record) => (
          <p>{`${record?.organization_fine_percentage || 0} %`}</p>
        ),
      },
    ];
    /* table column config */
    setColumns(
      selectedFilterStatus === "user"
        ? tempTableColumns?.filter(
            (element) =>
              !["organization_fine_percentage"].includes(element.dataIndex)
          )
        : selectedFilterStatus === "service_provider"
        ? tempTableColumns?.filter(
            (element) =>
              ![
                "time_limit_hours",
                "before_time_limit_refund_percentage",
                "after_time_limit_refund_percentage",
              ].includes(element.dataIndex)
          )
        : []
    );
  }, [selectedFilterStatus]);
  /* initial dependencies rendering */

  return (
    <div className={styles.adsListContainer}>
      <Flex vertical gap="2rem">
        <Flex justify="space-between">
          <Flex gap="1rem">
            <Button
              type="default"
              shape="circle"
              size="small"
              icon={<ArrowLeftOutlined />}
              onClick={() =>
                navigate(
                  baseRouteMakerForSuperAdmin(routes.SALES_PAGE_CONFIGURATION)
                )
              }
            />
            <Typography.Title level={2}>
              {t("Modules.Configuration.refundPolicy")}
            </Typography.Title>
          </Flex>
          <Radio.Group
            onChange={(event) => setSelectedFilterStatus(event.target.value)}
            value={selectedFilterStatus}
            options={[
              { label: t("Modules.Configuration.user"), value: "user" },
              {
                label: t("Modules.Configuration.serviceProvider"),
                value: "service_provider",
              },
            ]}
          />
        </Flex>

        {loading || debounceLoading ? (
          <Spinner />
        ) : (
          <Table
            dataSource={[systemSettings?.refund_policy]}
            columns={columns}
            // pagination={paginationObj}
          />
        )}
      </Flex>
    </div>
  );
};

export default ConfigurationList;
